import { APP_URL } from './APP_URL';

export const DEFAULT_META_DATA = {
  title: 'Totemnotes',
  description:
    'Totemnotes - інтернет магазин дизайнерських планерів, стікерів, блокнотів та іншої креативної канцелярії українського бренду. Кожне замовлення відправляється в подарунковій упаковці. Доставка по Україні 1-3 дні. Створено у Львові.',
  imageUrl: `${APP_URL}/images/facebook.jpg`
};
